module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/marquee_desktop3-62e3470564fb008861e586f487e4b264.jpg";